{
  "version": 1,
  "asset_id": "9059ce0c-02aa-4e29-9fb5-82d655d38956",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/9059ce0c-02aa-4e29-9fb5-82d655d38956/verhuislift-appartement-verhuiswagen.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/9059ce0c-02aa-4e29-9fb5-82d655d38956/verhuislift-appartement-verhuiswagen.jpg",
  "original_filename": "verhuislift-appartement-verhuiswagen.jpg",
  "size": 144345,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T19:15:16Z"
}
